export default __webpack_public_path__ + "static/blue-mobile-page-background-0b63ff0e692b119e7434cfa7ae22c488.png";